import HeroSection from '../components/HeroSection'
import CreationSection from '../components/CreationSection'
import Footer from '../components/Footer'
import LeaderVR from '../components/LeaderVR'

const HomePage = () => {
  return (
    <div>
        <HeroSection />
        <LeaderVR />
        <CreationSection />
        <Footer />
    </div>
  )
}

export default HomePage